/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BikeleasingV2EmployerContributionDTO
 */
export interface BikeleasingV2EmployerContributionDTO {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2EmployerContributionDTO
     */
    'type': BikeleasingV2EmployerContributionDTOTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof BikeleasingV2EmployerContributionDTO
     */
    'percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof BikeleasingV2EmployerContributionDTO
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2EmployerContributionDTO
     */
    'currency'?: string;
}

export const BikeleasingV2EmployerContributionDTOTypeEnum = {
    Absolute: 'Absolute',
    Percentage: 'Percentage'
} as const;

export type BikeleasingV2EmployerContributionDTOTypeEnum = typeof BikeleasingV2EmployerContributionDTOTypeEnum[keyof typeof BikeleasingV2EmployerContributionDTOTypeEnum];


